var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from "vue";
import { getObjectStoreDetails } from "@/api/objectStores";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DescribeObjectStore from "@/components/ObjectStore/DescribeObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ShowSelectedObjectStore',
    props: {
        forWhat: null,
        preferredObjectStoreId: null
    },
    setup(__props) {
        const props = __props;
        const objectStore = ref(null);
        const loading = ref(true);
        const error = ref(null);
        function fetch() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    objectStore.value = yield getObjectStoreDetails(props.preferredObjectStoreId);
                }
                catch (e) {
                    error.value = errorMessageAsString(e);
                }
                finally {
                    loading.value = false;
                }
            });
        }
        watch(() => props.preferredObjectStoreId, () => __awaiter(this, void 0, void 0, function* () {
            fetch();
        }));
        fetch();
        const loadingMessage = "Loading storage location details";
        return { __sfc: true, props, objectStore, loading, error, fetch, loadingMessage, LoadingSpan, DescribeObjectStore };
    }
});
